import {ResourceDrawerActivitiesSection} from '@/shared/components/ui/resource-drawer-sections'
import {useTradeNameContext} from '@/shared/contexts/trade-name'
import {Tabs} from '@chakra-ui/react'

export function HistoryTab() {
  const {activities} = useTradeNameContext()

  return (
    <Tabs.Content value="history">
      <ResourceDrawerActivitiesSection activities={activities} />
    </Tabs.Content>
  )
}
